import { type GetMyPassengerResponse, useGetMyPassengersQuery } from '@massilia/queries'
import { Button, Separator } from '@massilia/ui'
import { Loader2, Plus } from 'lucide-react'
import { type ReactNode, useState } from 'react'

import { PassengerCard } from './passenger-card'
import { PassengerFormDialog } from './passenger-form-dialog'

export function PassengersSection() {
  const { data: passengers = [], isLoading } = useGetMyPassengersQuery()
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const [editingPassenger, setEditingPassenger] = useState<GetMyPassengerResponse | undefined>()

  const handleEdit = (passenger: GetMyPassengerResponse) => {
    setEditingPassenger(passenger)
    setIsDialogOpen(true)
  }

  const handleAdd = () => {
    setEditingPassenger(undefined)
    setIsDialogOpen(true)
  }

  const handleClose = () => {
    setIsDialogOpen(false)
    setEditingPassenger(undefined)
  }

  let passengersContent: ReactNode
  if (isLoading) {
    passengersContent = (
      <div className="flex items-center justify-center py-8">
        <Loader2 className="size-6 animate-spin text-brand-600" />
      </div>
    )
  } else if (passengers.length === 0) {
    passengersContent = (
      <p className="py-4 text-sm text-gray-light-500">
        Aucun passager enregistré. Ajoutez vos voyageurs fréquents pour pré-remplir vos
        réservations.
      </p>
    )
  } else {
    passengersContent = (
      <div className="space-y-4">
        {passengers.map((passenger) => (
          <PassengerCard key={passenger.id} onEdit={handleEdit} passenger={passenger} />
        ))}
      </div>
    )
  }

  return (
    <>
      <div className="flex items-center justify-between">
        <h3 className="text-base font-semibold text-gray-light-900">Passagers enregistrés</h3>
        <Button
          className="gap-1 bg-brand-600 text-white hover:bg-brand-700"
          onClick={handleAdd}
          size="sm"
        >
          <Plus className="size-4" />
          Ajouter un passager
        </Button>
      </div>

      {passengersContent}

      <Separator />

      <PassengerFormDialog
        isOpen={isDialogOpen}
        onClose={handleClose}
        passenger={editingPassenger}
      />
    </>
  )
}
